module.exports = require("node:util/types");